export default __webpack_public_path__ + "static/media/logo.e7769aed.png";